import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx } from "vue"

const _hoisted_1 = { id: "sales-admin-app" }

import SalesAdminPage from "./SalesAdminPage.vue";
import Toast from "@components/Toast/Toast.vue";
import { useToast } from "@components/Toast/toast-service";


export default /*@__PURE__*/_defineComponent({
  __name: 'SalesAdminPageApp',
  setup(__props) {

const { toasts, removeToast } = useToast();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SalesAdminPage),
    _createVNode(_TransitionGroup, {
      name: "toast",
      tag: "div",
      class: "toast-stack",
      "aria-live": "polite",
      "aria-atomic": "true",
      "aria-label": "Notifications"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(toasts), (toast) => {
          return (_openBlock(), _createBlock(Toast, {
            key: toast.id,
            toast: toast,
            onClose: ($event: any) => (_unref(removeToast)(toast.id))
          }, null, 8 /* PROPS */, ["toast", "onClose"]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    })
  ]))
}
}

})